import {Button, Form, Input, NavBar, Selector, Toast} from "antd-mobile";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useEffect} from "react";
import {hubtelInitiate} from "../../common/ApiAction";
import {getLoginUserInfo, TOASTDURATION} from "../../common/Utils";

const channelList = [
    {value: 'mtn-gh-direct-debit', label: 'MTN Ghana'},
    {value: 'vodafone-gh-direct-debit', label: 'Telecel Ghana'}
]

const HubtelCreate = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const [form] = Form.useForm();

    const onFinish = (values: any) => {
        let userInfo : API.CurrentUser | null = getLoginUserInfo();
        if (!userInfo) {
            Toast.show({icon: 'fail', content: "Not Login!", duration: TOASTDURATION})
            return;
        }
        if (values.channel) {
            values.channel = values.channel[0];
        }
        values.createById = userInfo.id;
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        hubtelInitiate(values).then((res: any) => {
            Toast.clear();
            if (res.executed) {
                navigate('/hubtel/details', {state: res.data});
            } else {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            }
        }).catch((err: any) => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
        })
    }
    useEffect(() => {
        if (location.state) {
            form.setFieldsValue({
                orderNo: location.state.orderNo,
                customerMsisdn: location.state.customerMsisdn,
                customerName: location.state.customerName
            })
        }
    },[location, form])
    const back = () => {
        navigate(-1);
    };
    return <div style={{display: "flex", flexDirection: "column", width: '100%', backgroundColor: '#F5F6FA', resize: "none", overflow: "auto"}}>
        <NavBar style={{backgroundColor: '#FFF'}} onBack={back}>Create Preapproval</NavBar>
        <div>
            <Form
                onFinish={onFinish}
                mode={'card'}
                form={form}
                requiredMarkStyle='asterisk'
                footer={<Button shape='rounded' type='submit' block color='primary' size='middle'>{t('create_order_submit')}</Button>}>
                <Form.Header>{t('create_order_user_info')}</Form.Header>
                <Form.Item name='orderNo' label={t('common_ordere_no')} rules={[{ required: true, message: t('common_ordere_no') }]}>
                    <Input disabled placeholder={t('common_ordere_no')} />
                </Form.Item>
                <Form.Item name='customerName' label={t('create_order_user_name')} rules={[{ required: true, message: t('create_order_user_name') }]}>
                    <Input disabled placeholder={t('create_order_user_name')} />
                </Form.Item>
                <Form.Item name='customerMsisdn' label={t('create_order_user_mobile')} rules={[{ required: true, message: t('create_order_user_mobile') }]}>
                    <Input disabled placeholder={t('create_order_user_mobile')} />
                </Form.Item>
                <Form.Item name='channel' label={t('hubtel_direct_debit_channel')} rules={[{ required: true, message: t('hubtel_direct_debit_channel') }]}>
                    <Selector columns={2} options={channelList} />
                </Form.Item>
            </Form>
        </div>
    </div>;
}
export default HubtelCreate;
